export default __webpack_public_path__ + "static/media/chicken-red.d50384dc.svg";